module.exports = __webpack_public_path__ + "static/media/Pi.6e90badf.png";